import LookupReferenceDataItemChip from "./LookupReferenceDataItemChip";

export default LookupReferenceDataItemChip;
